/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PricingInputs */

const en_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const de_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise`)
};

const fr_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarification`)
};

const es_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios`)
};

const it_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi`)
};

const nl_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijzen`)
};

const pl_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cennik`)
};

const fi_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinnasto`)
};

const da_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priser`)
};

const sv_nav_pricing = /** @type {(inputs: Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prissättning`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Nav_PricingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_pricing = /** @type {((inputs?: Nav_PricingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PricingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_pricing(inputs)
	if (locale === "fr") return fr_nav_pricing(inputs)
	if (locale === "es") return es_nav_pricing(inputs)
	if (locale === "it") return it_nav_pricing(inputs)
	if (locale === "nl") return nl_nav_pricing(inputs)
	if (locale === "pl") return pl_nav_pricing(inputs)
	if (locale === "fi") return fi_nav_pricing(inputs)
	if (locale === "da") return da_nav_pricing(inputs)
	if (locale === "sv") return sv_nav_pricing(inputs)
	return en_nav_pricing(inputs)
});